type PaginationProps = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
};

function buildPages(page: number, totalPages: number): (number | "gap")[] {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }
  const pages: (number | "gap")[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  if (start > 2) pages.push("gap");
  for (let index = start; index <= end; index += 1) pages.push(index);
  if (end < totalPages - 1) pages.push("gap");
  pages.push(totalPages);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  return (
    <nav className="flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300/70 px-3 font-label text-xs text-foreground-600 transition-colors hover:border-primary-500 hover:text-foreground-900 disabled:cursor-not-allowed disabled:opacity-35 disabled:hover:border-background-300/70"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((item, index) =>
        item === "gap" ? (
          <span key={`gap-${index}`} className="px-1 font-label text-xs text-foreground-500">
            ···
          </span>
        ) : (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            aria-current={item === page ? "page" : undefined}
            className={`h-9 min-w-9 cursor-pointer rounded-md px-2 font-label text-xs transition-colors ${
              item === page
                ? "bg-primary-600 font-semibold text-background-50"
                : "border border-background-300/70 text-foreground-600 hover:border-primary-500 hover:text-foreground-900"
            }`}
          >
            {item}
          </button>
        ),
      )}

      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300/70 px-3 font-label text-xs text-foreground-600 transition-colors hover:border-primary-500 hover:text-foreground-900 disabled:cursor-not-allowed disabled:opacity-35 disabled:hover:border-background-300/70"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}